<template>
  <StepLayout
    :back="back"
    :save="save"
    :next="next"
    :isEditStepRoute="isEditStepRoute"
    buttonDataEc="envelopes_documents_page"
  >
    <template slot="title">
      {{ $t('ui.envelopes.create.steps.fields.title') }}
    </template>

    !!FIELDS GO HERE!!
  </StepLayout>
</template>

<script setup>
// @ts-check
import { computed } from 'vue';

import {
  useEnvelopesRoutes,
  useEnvelopesStepsNavigation,
} from '@/composables/envelopes';

import StepLayout from '@/components/layouts/StepLayout';

const { isEditStepRoute } = useEnvelopesRoutes();

const updateValue = computed(() => ({}));
const isValid = computed(() => true);

// action param is temporary, will be replaced when tanstack query is implemented
const { back, save, next } = useEnvelopesStepsNavigation(
  'envelopes/updateEnvelopes',
  updateValue,
  isValid,
);
</script>
